<template>
  <div>
    <!-- toasts message -->
       <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="confirmModel" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmModel = false"
              >Disagree</v-btn
            >
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
              >Agree</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <!-- <executionForm :formSchema="formSchema" v-on:emitCloseModal="close"></executionForm> -->

    <v-card-title>
      <h2>Procurement Execution</h2>
      <v-spacer></v-spacer>
      <!-- <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field> -->
    </v-card-title>

    <br />
    <v-flex xs12 sm10 md6 offset-sm1 offset-md3>
      <v-autocomplete
        label="Package No"
        item-text="package_no"
        item-value="id"
        v-model="formSchema.package_id"
        :items="items"
        :rules="[(v) => !!v || 'Field is required']"
        required
      ></v-autocomplete>
    </v-flex>

          <v-flex xs12 sm10 md6 offset-sm1 offset-md3>
           <DatePicker
           :key="formSchema.id"
           :inputData="{index:1,fieldName:'start_date', fieldValue:formSchema.start_date, label:'Start Date'}"
           @setValue="setDateValue"
           ></DatePicker>
         </v-flex>

          <v-flex xs12 sm10 md6 offset-sm1 offset-md3>
            <DatePicker
            :key="formSchema.id"
            :inputData="{index:2,fieldName:'end_date', fieldValue:formSchema.end_date, label:'End Date'}"
            @setValue="setDateValue"
            ref="setRange"
            ></DatePicker>
          </v-flex>

    <td class="justify-center layout px-0">
      <!-- <div style="height: 50px; width: 100px; background: #000; color: #fff; padding: 10px; font-size: 1.5em;"> -->
      <!-- <button type="submit">Search</button> -->
      <div>
        <v-btn
        color="primary"
        dark
        slot="activator"
        class="mb-2"
        
        @click="setSearchValue"
        >Search</v-btn
        >
      </div>
    </td>

    <br />
    <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    <!-- </v-data-table> -->
  </div>
</template>

<script>
let commonService = require("../../../services/common.service");

//import executionForm from "./executionForm.vue";
import { preFix } from "../../../vuex/api";
import Axios from "axios";
import DatePicker from "../../global/date_picker";

export default {
  // components: {
  //   executionForm
  // },
  components: {
    DatePicker
  },

  data: () => ({
    dialog: false,
    totalItems: 0,
    loading: true,
    pagination: {
      sortBy: "id",
      descending: true,
    },
    search: "",
    items: [],
 SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
    delete_id: "",
    row_index: "",
    confirmModel: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    leaveTypeModal: false,
    formSchema: {
      package_id: "",
      start_date: "",
      end_date: "",
    },

    queryData: {
      sortBy: "id",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      search_val: "",
    },
  }),

  computed: {
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    },
  },
  created(){
     commonService.getAllData("proc_execution").then((res) => {
        this.items = res.data;
        this.loading = false;
      });
  },

  mounted() {
    this.loadData();
  },

  methods: {
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },
    loadData(pagination) {
      commonService.getAllData("proc_execution").then((res) => {
        this.items = res.data;
        this.loading = false;
      });
    },

    editItem(id, data) {
      this.formSchema = data;
      this.leaveTypeModal = true;
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.confirmModel = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "proc_execution").then((res) => {
        this.items.splice(row_index, 1);
        this.close(res.message);
        this.confirmModel = false;
      });
    },

    close(data) {
      this.leaveTypeModal = false;
      if (data.status == 1) {
        this.data = data;
        this.message = data.message;
        this.snackbar = true;
        this.loadData();
      }
    },
    setSearchValue(){
       sessionStorage.setItem('search_id', this.formSchema.package_id)
       sessionStorage.setItem('search_sdate', this.formSchema.start_date)
       sessionStorage.setItem('search_edate', this.formSchema.end_date)
       this.$router.push('/procurement/executions')
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/procurement/execution/execution_list.vue